
export { isRegisteredSuccessAtom } from "/home/runner/work/capsicum/capsicum/libs/socios-core/shared/auth/index.ts"